import { render, staticRenderFns } from "./SwitchLogin.vue?vue&type=template&id=79f3c57e&scoped=true&"
import script from "./SwitchLogin.vue?vue&type=script&lang=js&"
export * from "./SwitchLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f3c57e",
  null
  
)

export default component.exports